import { useWorkspaceContext } from "../state/workspaceContext";
import { useUser } from "./useUser";

export function useOnboardingStatus() {
    const { activeWorkspace } = useWorkspaceContext();
    const user = useUser();

    if (!user?.onboardingComplete) {
        return false;
    }

    if (!activeWorkspace) {
        return true;
    }

    return !!activeWorkspace.onboardingCompletedAt;
}
